<template lang='pug'>
  footer
</template>

<script>
export default {
  components: {},
  name: 'BionicMetricsFooter',
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
